import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCompactImagesConfig } from '@/data/landingConfig/landingCompactImagesConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CompactImages } from './schemaObject';

interface Props {}
const CompactImages: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CompactImages} />
			<LandingTemplate
				data={landingCompactImagesConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default CompactImages;
